import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../AppContext";

import "../components/PostForm.css";
import MultiImageUpload from "../components/MultiImage/MultiImageUpload";


export const NewPost = () => {
    const navigate = useNavigate();
    const { port, userID, token, addAlert } = useContext(AppContext);
    const [post, setPosts] = useState({
        name: "",
        address: "",
        rent: "",
        description: "",
        images: [],
        contact: 0,
        city: "",
        startDate: "", // New state for start date
        endDate: "",   // New state for end date
        subleaseRooms: 1, // New state for subleased rooms
        totalBedrooms: 1, // New state for total bedrooms
        totalBathrooms: 1, // New state for total bathrooms
        preferences: "None", // New state for preferences
        userOwner: userID
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const handleChange = (event) => {
        const { name, value } = event.target;
        setPosts({
            ...post,
            [name]: value
        });
    };
    const handleFileChange = (updatedImages) => {
        setPosts({
            ...post,
            images: updatedImages
        });
    };
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsSubmitting(true); // Disable the button
        
        const formData = new FormData();
        for (const key in post) {
            if (key === 'images') {
                post.images.map(image => {
                    formData.append('images', image.file);
                    return image;
                });
            } else {
                formData.append(key, post[key]);
            }
        }
        
        axios.post(`${port}/posts/`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Bearer ${token}`
            }
        })
        .then(() => {
            addAlert("Post created successfully", "success");
            navigate("/home");
        })
        .catch(() => {
            addAlert("Failed to create post. Please try again later.", "danger");
            setIsSubmitting(false); // Re-enable the button on error
        });
    };

    return (
        <div className="container">
            <div className="new-post">
                <h1 className="text-center mb-4">New Post</h1>
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">Name</label>
                        <input type="text" className="form-control" id="name" name="name" onChange={handleChange} required />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="address" className="form-label">Street Address</label>
                        <input type="text" className="form-control" id="address" name="address" onChange={handleChange} required />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="city" className="form-label">City</label>
                        <select className="form-select" id="city" name="city" onChange={handleChange} required>
                            <option value="">Select a city</option>
                            <option value="Champaign">Champaign</option>
                            <option value="Urbana">Urbana</option>
                            <option value="Savoy">Savoy</option>
                        </select>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="rent" className="form-label">Rent</label>
                        <input type="number" className="form-control" id="rent" name="rent" onChange={handleChange} required />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="subleaseRooms" className="form-label">Sublease Rooms</label>
                        <input type="number" className="form-control" id="subleaseRooms" name="subleaseRooms" min="1" onChange={handleChange} required placeholder="How many rooms are you subleasing?" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="totalBedrooms" className="form-label">Bedrooms</label>
                        <input type="number" className="form-control" id="totalBedrooms" name="totalBedrooms" min="1" onChange={handleChange} required placeholder="Total number of bedrooms in the apartment" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="totalBathrooms" className="form-label">Bathrooms</label>
                        <input type="number" className="form-control" id="totalBathrooms" name="totalBathrooms" min="1" onChange={handleChange} required placeholder="Total number of bathrooms in the apartment" />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="contact" className="form-label">Contact</label>
                        <input type="text" className="form-control" id="contact" name="contact" onChange={handleChange} required placeholder="Phone Number, Email, Instagram, Snapchat etc." />
                    </div>
                    
                    <div className="mb-3">
                        <label htmlFor="startDate" className="form-label">Sublease Start Date</label>
                        <input type="date" className="form-control" id="startDate" name="startDate" onChange={handleChange} required />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="endDate" className="form-label">Sublease End Date</label>
                        <input type="date" className="form-control" id="endDate" name="endDate" onChange={handleChange} required />
                    </div>
                    
                    <div className="mb-3">
                        <label htmlFor="preferences" className="form-label">Preferences</label>
                        <select className="form-select" id="preferences" name="preferences" onChange={handleChange} required>
                            <option value="None">None</option>
                            <option value="Only Males">Only Males</option>
                            <option value="Only Females">Only Females</option>
                        </select>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="images" className="form-label">Images</label>
                        <MultiImageUpload 
                            images={post.images || []}
                            onChange={handleFileChange} 
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="description" className="form-label">Other Information</label>
                        <textarea className="form-control" id="description" name="description" onChange={handleChange}/>
                    </div>
                    <button 
                        type="submit" 
                        className="btn btn-primary w-100" 
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Creating Post...' : 'Create Post'}
                    </button>
                </form>
            </div>
        </div>
    );
};
